import axios from 'axios'

export default {
    get: () => axios.get('events-codes'),
    getDefault: () => axios.get('events-codes/default'),
    store: (data) => axios.post('events-codes/store', data),
    update: (data) => axios.post('events-codes/update', data),
    delete: (id) => axios.post('events-codes/delete', id)
}